import React from "react";
import { Box, Flex, Grid, GridItem } from "@chakra-ui/react";
import { VeriDatePickerMonthsYearsViewProps } from "./VeriDatePickerMonthsYearsView.types";
import { monthShortNames } from "../../../../utils/dates";
import { DatePickerButton } from "../../components/DatePickerButton";
import { useVeriDatePicker } from "../../VeriDatePickerContext";
import { getRightAndLeftYearsList } from "../../utils";

const VeriDatePickerMonthsYearsView: React.FC<
  VeriDatePickerMonthsYearsViewProps
> = ({ ...rest }) => {
  const datePicker = useVeriDatePicker();
  const selectedDate = new Date(datePicker.selectedDateString || new Date());
  const yearsDate = new Date();
  yearsDate.setFullYear(yearsDate.getFullYear() + datePicker.yearStep);
  const years = getRightAndLeftYearsList(yearsDate);

  const getDataWithNewYear = (year: number) => {
    const _nDate = new Date(datePicker.dateString || new Date());
    _nDate.setFullYear(year);
    return _nDate;
  };

  const getDataWithNewMonth = (month: number) => {
    const _nDate = new Date(datePicker.dateString || new Date());
    _nDate.setMonth(month);
    return _nDate;
  };

  const changeYear = (year: number) => {
    const _nDate = new Date(datePicker.selectedDateString || new Date());
    _nDate.setFullYear(year);
    datePicker.setDate(_nDate);
  };

  const changeMonth = (month: number) => {
    const _nDate = new Date(datePicker.selectedDateString || new Date());
    _nDate.setMonth(month);
    datePicker.setDate(_nDate);
  };

  return (
    <Box {...rest}>
      <Flex>
        <Grid
          gridTemplateColumns={"repeat(2, 1fr)"}
          w={"40%"}
          borderRight={"1px solid"}
          borderRightColor={"grey.1000"}
          pr={2}
          py={6}
        >
          {monthShortNames.map((monthName, index) => (
            <GridItem key={index}>
              <DatePickerButton
                isDisabled={
                  !datePicker.isDateEnabled(getDataWithNewMonth(index))
                }
                isSelected={selectedDate.getMonth() === index}
                onClick={changeMonth.bind(null, index)}
              >
                {monthName}
              </DatePickerButton>
            </GridItem>
          ))}
        </Grid>
        <Grid gridTemplateColumns={"repeat(3, 1fr)"} w={"60%"} pl={2} py={6}>
          {years.map((yearName, index) => (
            <GridItem key={index}>
              <DatePickerButton
                isDisabled={
                  !datePicker.isDateEnabled(getDataWithNewYear(yearName))
                }
                isSelected={selectedDate.getFullYear() === yearName}
                onClick={changeYear.bind(null, yearName)}
              >
                {yearName}
              </DatePickerButton>
            </GridItem>
          ))}
        </Grid>
      </Flex>
    </Box>
  );
};

export default VeriDatePickerMonthsYearsView;
